class SiteModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.validate()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.externalEls.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, `click`, this.handleTrigger)
    })
    this.els.close.elements.forEach((close) => {
      this.listeners.add(close, `click`, this.handleClose)
    })
  }

  validate () {
    if (!this.externalEls?.trigger?.exists) {
      throw new Error(`Missing trigger element`)
    }
  }

  handleTrigger (e) {
    if (e.currentTarget.dataset.siteModalKey !== this.dataset.siteModalKey) {
      return
    }

    document.body.classList.toggle('util-SiteOverflowed', true)
    this.setAttribute('aria-hidden', 'false')
    this.sendCSEvent(true)
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
    this.sendCSEvent()
  }

  sendCSEvent (isOpen) {
    window._uxa = window._uxa || []
    const locationURL = isOpen
      ? `${window.location.search + (window.location.search ? '&' : '?')}${this.dataset.siteModalKey}`
      : window.location.search

    window._uxa.push(['setQuery', locationURL])

    window._uxa.push([
      'trackPageview',
      window.location.pathname + window.location.hash.replace('#', '?__'),
    ])

    if (isOpen) {
      window._uxa.push(['setQuery', window.location.search])
    }
  }
}

if (!customElements.get('site-modal')) {
  customElements.define('site-modal', SiteModal)
}
